// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMScatterChart-module__font-s-10___M5D6z {
  font-size: 10px !important;
}

.CGMScatterChart-module__font-s-12___HNGoV {
  font-size: 12px !important;
}

.CGMScatterChart-module__font-s-13___j3NDA {
  font-size: 13px !important;
}

.CGMScatterChart-module__font-s-14___RpIwi {
  font-size: 14px !important;
}

.CGMScatterChart-module__font-s-15___SyCQW {
  font-size: 15px !important;
}

.CGMScatterChart-module__font-s-16___TUduM {
  font-size: 16px !important;
}

.CGMScatterChart-module__font-s-18___rWKYA {
  font-size: 18px !important;
}

.CGMScatterChart-module__font-s-20___Zv7LE {
  font-size: 20px !important;
}

.CGMScatterChart-module__font-s-22___V13as {
  font-size: 22px !important;
}

.CGMScatterChart-module__font-s-28___Et9lN {
  font-size: 28px !important;
}

.CGMScatterChart-module__font-w-400___dW7S8 {
  font-weight: 400 !important;
}

.CGMScatterChart-module__font-w-500___qeor8 {
  font-weight: 500 !important;
}

.CGMScatterChart-module__font-w-600___J0hun {
  font-weight: 600 !important;
}

.CGMScatterChart-module__font-w-700___NG2Cb {
  font-weight: 700 !important;
}

.CGMScatterChart-module__p-5____9ad0 {
  padding: 5px !important;
}

.CGMScatterChart-module__p-12___Hz4TX {
  padding: 12px !important;
}

.CGMScatterChart-module__p-16___bYPvZ {
  padding: 16px !important;
}

.CGMScatterChart-module__p-30___YKElw {
  padding: 30px !important;
}

.CGMScatterChart-module__p-b-0___SjHCg {
  padding-bottom: 0 !important;
}

.CGMScatterChart-module__p-b-5___INXe7 {
  padding-bottom: 5px !important;
}

.CGMScatterChart-module__p-b-10___LUuik {
  padding-bottom: 10px !important;
}

.CGMScatterChart-module__p-b-12___FlOZq {
  padding-bottom: 12px !important;
}

.CGMScatterChart-module__p-b-16___o173t {
  padding-bottom: 16px !important;
}

.CGMScatterChart-module__p-b-18___y_URl {
  padding-bottom: 18px !important;
}

.CGMScatterChart-module__p-b-20___Ms5gN {
  padding-bottom: 20px !important;
}

.CGMScatterChart-module__p-b-25___IXWWn {
  padding-bottom: 25px !important;
}

.CGMScatterChart-module__p-b-30___Dnj9m {
  padding-bottom: 30px !important;
}

.CGMScatterChart-module__p-b-50___t2JAa {
  padding-bottom: 50px !important;
}

.CGMScatterChart-module__p-t-0____ylH0 {
  padding-top: 0 !important;
}

.CGMScatterChart-module__p-t-12___oiWz1 {
  padding-top: 12px !important;
}

.CGMScatterChart-module__p-t-16___ZFn2J {
  padding-top: 16px !important;
}

.CGMScatterChart-module__p-t-18___H0vWn {
  padding-top: 18px !important;
}

.CGMScatterChart-module__p-t-20___jELfY {
  padding-top: 20px !important;
}

.CGMScatterChart-module__p-t-30___QD23E {
  padding-top: 30px !important;
}

.CGMScatterChart-module__p-t-40___WVAJp {
  padding-top: 40px !important;
}

.CGMScatterChart-module__p-t-50___XYUdw {
  padding-top: 50px !important;
}

.CGMScatterChart-module__p-l-20___lOfri {
  padding-left: 20px !important;
}

.CGMScatterChart-module__p-l-30___QCt8F {
  padding-left: 30px !important;
}

.CGMScatterChart-module__p-l-40___cbgRd {
  padding-left: 40px !important;
}

.CGMScatterChart-module__p-r-16___DLxlR {
  padding-right: 16px !important;
}

.CGMScatterChart-module__p-r-20___QkMdI {
  padding-right: 20px !important;
}

.CGMScatterChart-module__p-r-30___SqfZk {
  padding-right: 30px !important;
}

.CGMScatterChart-module__p-r-50___stI_L {
  padding-right: 50px !important;
}

.CGMScatterChart-module__p-r-60___sYc4P {
  padding-right: 60px !important;
}

.CGMScatterChart-module__m-b-1___F_GQ0 {
  margin-bottom: 1px !important;
}

.CGMScatterChart-module__m-b-2___NusVT {
  margin-bottom: 2px !important;
}

.CGMScatterChart-module__m-b-6___MRInw {
  margin-bottom: 6px !important;
}

.CGMScatterChart-module__m-b-8___hV92k {
  margin-bottom: 8px !important;
}

.CGMScatterChart-module__m-b-10___RFrNs {
  margin-bottom: 10px !important;
}

.CGMScatterChart-module__m-b-14___jJlRb {
  margin-bottom: 14px !important;
}

.CGMScatterChart-module__m-b-16___HCgjq {
  margin-bottom: 16px !important;
}

.CGMScatterChart-module__m-b-20___BXymU {
  margin-bottom: 20px !important;
}

.CGMScatterChart-module__m-b-22___P3wlq {
  margin-bottom: 22px !important;
}

.CGMScatterChart-module__m-b-24___eJcsi {
  margin-bottom: 24px !important;
}

.CGMScatterChart-module__m-b-30___sKfDj {
  margin-bottom: 30px !important;
}

.CGMScatterChart-module__m-b-32___pdIEw {
  margin-bottom: 32px !important;
}

.CGMScatterChart-module__m-b-40___kenXp {
  margin-bottom: 40px !important;
}

.CGMScatterChart-module__m-t-2___AeFua {
  margin-top: 2px !important;
}

.CGMScatterChart-module__m-t-3___TXE0m {
  margin-top: 3px !important;
}

.CGMScatterChart-module__m-t-4___Qd8aD {
  margin-top: 4px !important;
}

.CGMScatterChart-module__m-t-5___ixpz1 {
  margin-top: 5px !important;
}

.CGMScatterChart-module__m-t-8___iCBgH {
  margin-top: 8px !important;
}

.CGMScatterChart-module__m-t-10___DPQxL {
  margin-top: 10px !important;
}

.CGMScatterChart-module__m-t-15___Te3qh {
  margin-top: 15px !important;
}

.CGMScatterChart-module__m-t-16___F832o {
  margin-top: 16px !important;
}

.CGMScatterChart-module__m-t-20___AncSb {
  margin-top: 20px !important;
}

.CGMScatterChart-module__m-t-22___chYg0 {
  margin-top: 22px !important;
}

.CGMScatterChart-module__m-t-30___FnWUZ {
  margin-top: 30px !important;
}

.CGMScatterChart-module__m-t-32___G1mP1 {
  margin-top: 32px !important;
}

.CGMScatterChart-module__m-l-auto___xs4zW {
  margin-left: auto !important;
}

.CGMScatterChart-module__m-l-4___Dn2E7 {
  margin-left: 4px !important;
}

.CGMScatterChart-module__m-l-5___m5N9o {
  margin-left: 5px !important;
}

.CGMScatterChart-module__m-l-6___cQjxP {
  margin-left: 6px !important;
}

.CGMScatterChart-module__m-l-8___D3bKW {
  margin-left: 8px !important;
}

.CGMScatterChart-module__m-l-10___jZXsO {
  margin-left: 10px !important;
}

.CGMScatterChart-module__m-l-16___NOWpw {
  margin-left: 16px !important;
}

.CGMScatterChart-module__m-l-20___zPPk4 {
  margin-left: 20px !important;
}

.CGMScatterChart-module__m-l-24___Ed2fD {
  margin-left: 24px !important;
}

.CGMScatterChart-module__m-l-30___M9aiA {
  margin-left: 30px !important;
}

.CGMScatterChart-module__m-l-35___ZX8aF {
  margin-left: 35px !important;
}

.CGMScatterChart-module__m-l-40___wwsvY {
  margin-left: 40px !important;
}

.CGMScatterChart-module__m-r-8___CVlLa {
  margin-right: 8px !important;
}

.CGMScatterChart-module__m-r-10___MkLZx {
  margin-right: 10px !important;
}

.CGMScatterChart-module__m-r-16___WrLrk {
  margin-right: 16px !important;
}

.CGMScatterChart-module__m-r-20___Zhv37 {
  margin-right: 20px !important;
}

.CGMScatterChart-module__m-r-24___kJe3d {
  margin-right: 24px !important;
}

.CGMScatterChart-module__m-r-30___ejEqB {
  margin-right: 30px !important;
}

.CGMScatterChart-module__m-r-40___fonJD {
  margin-right: 40px !important;
}

.CGMScatterChart-module__border-r-3___T_n9t {
  border-radius: 3px !important;
}

.CGMScatterChart-module__border-r-4___nxT5X {
  border-radius: 4px !important;
}

.CGMScatterChart-module__border-r-6___WFEqt {
  border-radius: 6px !important;
}

.CGMScatterChart-module__border-r-10___XCMxy {
  border-radius: 10px !important;
}

.CGMScatterChart-module__border-r-12___yv62X {
  border-radius: 12px !important;
}

.CGMScatterChart-module__border-r-16___oRmLn {
  border-radius: 16px !important;
}

.CGMScatterChart-module__border-r-50___UwUUu {
  border-radius: 50% !important;
}

.CGMScatterChart-module__primary-border___zuVot {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMScatterChart-module__primary-border-b___LjUMX {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMScatterChart-module__primary-border-t___bo3Tn {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMScatterChart-module__primary-border-l___RgcZM {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMScatterChart-module__primary-border-r___yvlQN {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMScatterChart-module__secondary-border___mkiax {
  border: 1px solid #637768;
}

.CGMScatterChart-module__secondary-border-b___Edjfw {
  border-bottom: 1px solid #637768;
}

.CGMScatterChart-module__secondary-border-t___VT6pE {
  border-top: 1px solid #637768;
}

.CGMScatterChart-module__secondary-border-l___BzaFe {
  border-left: 1px solid #637768;
}

.CGMScatterChart-module__secondary-border-r___HLoD_ {
  border-right: 1px solid #637768;
}

.CGMScatterChart-module__gap-0___JKal8 {
  gap: 0 !important;
}

.CGMScatterChart-module__gap-2___tWR0l {
  gap: 2px !important;
}

.CGMScatterChart-module__gap-4___hf8No {
  gap: 4px !important;
}

.CGMScatterChart-module__gap-5___t01Kp {
  gap: 5px !important;
}

.CGMScatterChart-module__gap-6___aCz70 {
  gap: 6px !important;
}

.CGMScatterChart-module__gap-8___U4lDc {
  gap: 8px !important;
}

.CGMScatterChart-module__gap-10___VcoFM {
  gap: 10px !important;
}

.CGMScatterChart-module__gap-12___K3Jwa {
  gap: 12px !important;
}

.CGMScatterChart-module__gap-14___WnGZG {
  gap: 14px !important;
}

.CGMScatterChart-module__gap-16___e8NhR {
  gap: 16px !important;
}

.CGMScatterChart-module__gap-18___pjwXz {
  gap: 18px !important;
}

.CGMScatterChart-module__gap-20___jRYTD {
  gap: 20px !important;
}

.CGMScatterChart-module__gap-24___E3AWN {
  gap: 24px !important;
}

.CGMScatterChart-module__gap-26___GDiF_ {
  gap: 26px !important;
}

.CGMScatterChart-module__gap-30___ALlN2 {
  gap: 30px !important;
}

.CGMScatterChart-module__gap-32___ttOtx {
  gap: 32px !important;
}

.CGMScatterChart-module__gap-40___MK3jS {
  gap: 40px !important;
}

.CGMScatterChart-module__gap-50___dRICh {
  gap: 50px !important;
}

.CGMScatterChart-module__flex-1___LTYjX {
  flex: 1;
}

.CGMScatterChart-module__flex-none___VzWRd {
  flex: none !important;
}

.CGMScatterChart-module__flex-column___IXnG0 {
  display: flex;
  flex-direction: column !important;
}

.CGMScatterChart-module__flex-row___IIyJA {
  display: flex;
  flex-direction: row !important;
}

.CGMScatterChart-module__vertically-centered___bO0OT {
  display: flex;
  align-items: center !important;
}

.CGMScatterChart-module__horizontally-centered___M6hlk {
  display: flex;
  justify-content: center !important;
}

.CGMScatterChart-module__horizontally-end___TnhM5 {
  display: flex;
  justify-content: end !important;
}

.CGMScatterChart-module__vertically-start___c7qkc {
  display: flex;
  align-items: start !important;
}

.CGMScatterChart-module__space-between___SIyOK {
  display: flex;
  justify-content: space-between !important;
}

.CGMScatterChart-module__flex-wrap___xqei9 {
  flex-wrap: wrap !important;
}

.CGMScatterChart-module__height-100___eTbjN {
  height: 100%;
}

.CGMScatterChart-module__width-50___z4jY6 {
  width: 50% !important;
}

.CGMScatterChart-module__width-100___pEMWO {
  width: 100%;
}

.CGMScatterChart-module__cursor-pointer___mCQBm {
  cursor: pointer;
}

.CGMScatterChart-module__cursor-not-allowed___w57SY {
  cursor: not-allowed !important;
}

.CGMScatterChart-module__absolute-centered___aVINy {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMScatterChart-module__absolute___qbE1F {
  position: absolute;
}

.CGMScatterChart-module__relative___fXReZ {
  position: relative;
}

.CGMScatterChart-module__fixed___B_xMK {
  position: fixed;
}

.CGMScatterChart-module__visible___hJTai {
  opacity: 1;
}

.CGMScatterChart-module__invisible___P_7Ld {
  opacity: 0;
}

.CGMScatterChart-module__col-90___EGQNL {
  width: 90% !important;
}

.CGMScatterChart-module__col-auto___NE3Li {
  width: auto !important;
}

.CGMScatterChart-module__medical-tabs___khV9Q {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMScatterChart-module__medical-table-new___z6m_0 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMScatterChart-module__medical-table-new___z6m_0:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMScatterChart-module__medical-table-new___z6m_0::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMScatterChart-module__medical-table-new___z6m_0::-webkit-scrollbar-track {
  display: none;
}
.CGMScatterChart-module__medical-table-new___z6m_0.CGMScatterChart-module__no-pagination___w4FiD {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMScatterChart-module__medical-table-new___z6m_0.CGMScatterChart-module__no-pagination___w4FiD:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMScatterChart-module__medical-table-new___z6m_0.CGMScatterChart-module__no-pagination___w4FiD::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMScatterChart-module__medical-table-new___z6m_0.CGMScatterChart-module__no-pagination___w4FiD::-webkit-scrollbar-track {
  display: none;
}

.CGMScatterChart-module__medical-table-empty___v_QVi {
  padding: 14px 40px !important;
}

.CGMScatterChart-module__icon-btn___gSnrz {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMScatterChart-module__search-icon___zN2PU {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMScatterChart-module__disable-select___eW22D {
  user-select: none;
}

.CGMScatterChart-module__break-word___rFBYP {
  word-break: break-word;
}

.CGMScatterChart-module__popup-clear-btn___x66_P {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMScatterChart-module__scroll-m-b-20___cG0Y_ {
  scroll-margin-bottom: 20px;
}

.CGMScatterChart-module__chart___YbwBo {
  width: 98%;
  height: 40vh;
  position: relative;
}
.CGMScatterChart-module__chart___YbwBo .CGMScatterChart-module__emptyPlaceholder___WXvXy {
  color: #375844;
  top: 45%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/charts/CGMScatterChart/CGMScatterChart.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,cAAA;EACA,QAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.chart {\n  width: 98%;\n  height: 40vh;\n  position: relative;\n\n  .emptyPlaceholder {\n    color: get-color(greenNew, dark);\n    top: 45%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMScatterChart-module__font-s-10___M5D6z`,
	"fontS12": `CGMScatterChart-module__font-s-12___HNGoV`,
	"fontS13": `CGMScatterChart-module__font-s-13___j3NDA`,
	"fontS14": `CGMScatterChart-module__font-s-14___RpIwi`,
	"fontS15": `CGMScatterChart-module__font-s-15___SyCQW`,
	"fontS16": `CGMScatterChart-module__font-s-16___TUduM`,
	"fontS18": `CGMScatterChart-module__font-s-18___rWKYA`,
	"fontS20": `CGMScatterChart-module__font-s-20___Zv7LE`,
	"fontS22": `CGMScatterChart-module__font-s-22___V13as`,
	"fontS28": `CGMScatterChart-module__font-s-28___Et9lN`,
	"fontW400": `CGMScatterChart-module__font-w-400___dW7S8`,
	"fontW500": `CGMScatterChart-module__font-w-500___qeor8`,
	"fontW600": `CGMScatterChart-module__font-w-600___J0hun`,
	"fontW700": `CGMScatterChart-module__font-w-700___NG2Cb`,
	"p5": `CGMScatterChart-module__p-5____9ad0`,
	"p12": `CGMScatterChart-module__p-12___Hz4TX`,
	"p16": `CGMScatterChart-module__p-16___bYPvZ`,
	"p30": `CGMScatterChart-module__p-30___YKElw`,
	"pB0": `CGMScatterChart-module__p-b-0___SjHCg`,
	"pB5": `CGMScatterChart-module__p-b-5___INXe7`,
	"pB10": `CGMScatterChart-module__p-b-10___LUuik`,
	"pB12": `CGMScatterChart-module__p-b-12___FlOZq`,
	"pB16": `CGMScatterChart-module__p-b-16___o173t`,
	"pB18": `CGMScatterChart-module__p-b-18___y_URl`,
	"pB20": `CGMScatterChart-module__p-b-20___Ms5gN`,
	"pB25": `CGMScatterChart-module__p-b-25___IXWWn`,
	"pB30": `CGMScatterChart-module__p-b-30___Dnj9m`,
	"pB50": `CGMScatterChart-module__p-b-50___t2JAa`,
	"pT0": `CGMScatterChart-module__p-t-0____ylH0`,
	"pT12": `CGMScatterChart-module__p-t-12___oiWz1`,
	"pT16": `CGMScatterChart-module__p-t-16___ZFn2J`,
	"pT18": `CGMScatterChart-module__p-t-18___H0vWn`,
	"pT20": `CGMScatterChart-module__p-t-20___jELfY`,
	"pT30": `CGMScatterChart-module__p-t-30___QD23E`,
	"pT40": `CGMScatterChart-module__p-t-40___WVAJp`,
	"pT50": `CGMScatterChart-module__p-t-50___XYUdw`,
	"pL20": `CGMScatterChart-module__p-l-20___lOfri`,
	"pL30": `CGMScatterChart-module__p-l-30___QCt8F`,
	"pL40": `CGMScatterChart-module__p-l-40___cbgRd`,
	"pR16": `CGMScatterChart-module__p-r-16___DLxlR`,
	"pR20": `CGMScatterChart-module__p-r-20___QkMdI`,
	"pR30": `CGMScatterChart-module__p-r-30___SqfZk`,
	"pR50": `CGMScatterChart-module__p-r-50___stI_L`,
	"pR60": `CGMScatterChart-module__p-r-60___sYc4P`,
	"mB1": `CGMScatterChart-module__m-b-1___F_GQ0`,
	"mB2": `CGMScatterChart-module__m-b-2___NusVT`,
	"mB6": `CGMScatterChart-module__m-b-6___MRInw`,
	"mB8": `CGMScatterChart-module__m-b-8___hV92k`,
	"mB10": `CGMScatterChart-module__m-b-10___RFrNs`,
	"mB14": `CGMScatterChart-module__m-b-14___jJlRb`,
	"mB16": `CGMScatterChart-module__m-b-16___HCgjq`,
	"mB20": `CGMScatterChart-module__m-b-20___BXymU`,
	"mB22": `CGMScatterChart-module__m-b-22___P3wlq`,
	"mB24": `CGMScatterChart-module__m-b-24___eJcsi`,
	"mB30": `CGMScatterChart-module__m-b-30___sKfDj`,
	"mB32": `CGMScatterChart-module__m-b-32___pdIEw`,
	"mB40": `CGMScatterChart-module__m-b-40___kenXp`,
	"mT2": `CGMScatterChart-module__m-t-2___AeFua`,
	"mT3": `CGMScatterChart-module__m-t-3___TXE0m`,
	"mT4": `CGMScatterChart-module__m-t-4___Qd8aD`,
	"mT5": `CGMScatterChart-module__m-t-5___ixpz1`,
	"mT8": `CGMScatterChart-module__m-t-8___iCBgH`,
	"mT10": `CGMScatterChart-module__m-t-10___DPQxL`,
	"mT15": `CGMScatterChart-module__m-t-15___Te3qh`,
	"mT16": `CGMScatterChart-module__m-t-16___F832o`,
	"mT20": `CGMScatterChart-module__m-t-20___AncSb`,
	"mT22": `CGMScatterChart-module__m-t-22___chYg0`,
	"mT30": `CGMScatterChart-module__m-t-30___FnWUZ`,
	"mT32": `CGMScatterChart-module__m-t-32___G1mP1`,
	"mLAuto": `CGMScatterChart-module__m-l-auto___xs4zW`,
	"mL4": `CGMScatterChart-module__m-l-4___Dn2E7`,
	"mL5": `CGMScatterChart-module__m-l-5___m5N9o`,
	"mL6": `CGMScatterChart-module__m-l-6___cQjxP`,
	"mL8": `CGMScatterChart-module__m-l-8___D3bKW`,
	"mL10": `CGMScatterChart-module__m-l-10___jZXsO`,
	"mL16": `CGMScatterChart-module__m-l-16___NOWpw`,
	"mL20": `CGMScatterChart-module__m-l-20___zPPk4`,
	"mL24": `CGMScatterChart-module__m-l-24___Ed2fD`,
	"mL30": `CGMScatterChart-module__m-l-30___M9aiA`,
	"mL35": `CGMScatterChart-module__m-l-35___ZX8aF`,
	"mL40": `CGMScatterChart-module__m-l-40___wwsvY`,
	"mR8": `CGMScatterChart-module__m-r-8___CVlLa`,
	"mR10": `CGMScatterChart-module__m-r-10___MkLZx`,
	"mR16": `CGMScatterChart-module__m-r-16___WrLrk`,
	"mR20": `CGMScatterChart-module__m-r-20___Zhv37`,
	"mR24": `CGMScatterChart-module__m-r-24___kJe3d`,
	"mR30": `CGMScatterChart-module__m-r-30___ejEqB`,
	"mR40": `CGMScatterChart-module__m-r-40___fonJD`,
	"borderR3": `CGMScatterChart-module__border-r-3___T_n9t`,
	"borderR4": `CGMScatterChart-module__border-r-4___nxT5X`,
	"borderR6": `CGMScatterChart-module__border-r-6___WFEqt`,
	"borderR10": `CGMScatterChart-module__border-r-10___XCMxy`,
	"borderR12": `CGMScatterChart-module__border-r-12___yv62X`,
	"borderR16": `CGMScatterChart-module__border-r-16___oRmLn`,
	"borderR50": `CGMScatterChart-module__border-r-50___UwUUu`,
	"primaryBorder": `CGMScatterChart-module__primary-border___zuVot`,
	"primaryBorderB": `CGMScatterChart-module__primary-border-b___LjUMX`,
	"primaryBorderT": `CGMScatterChart-module__primary-border-t___bo3Tn`,
	"primaryBorderL": `CGMScatterChart-module__primary-border-l___RgcZM`,
	"primaryBorderR": `CGMScatterChart-module__primary-border-r___yvlQN`,
	"secondaryBorder": `CGMScatterChart-module__secondary-border___mkiax`,
	"secondaryBorderB": `CGMScatterChart-module__secondary-border-b___Edjfw`,
	"secondaryBorderT": `CGMScatterChart-module__secondary-border-t___VT6pE`,
	"secondaryBorderL": `CGMScatterChart-module__secondary-border-l___BzaFe`,
	"secondaryBorderR": `CGMScatterChart-module__secondary-border-r___HLoD_`,
	"gap0": `CGMScatterChart-module__gap-0___JKal8`,
	"gap2": `CGMScatterChart-module__gap-2___tWR0l`,
	"gap4": `CGMScatterChart-module__gap-4___hf8No`,
	"gap5": `CGMScatterChart-module__gap-5___t01Kp`,
	"gap6": `CGMScatterChart-module__gap-6___aCz70`,
	"gap8": `CGMScatterChart-module__gap-8___U4lDc`,
	"gap10": `CGMScatterChart-module__gap-10___VcoFM`,
	"gap12": `CGMScatterChart-module__gap-12___K3Jwa`,
	"gap14": `CGMScatterChart-module__gap-14___WnGZG`,
	"gap16": `CGMScatterChart-module__gap-16___e8NhR`,
	"gap18": `CGMScatterChart-module__gap-18___pjwXz`,
	"gap20": `CGMScatterChart-module__gap-20___jRYTD`,
	"gap24": `CGMScatterChart-module__gap-24___E3AWN`,
	"gap26": `CGMScatterChart-module__gap-26___GDiF_`,
	"gap30": `CGMScatterChart-module__gap-30___ALlN2`,
	"gap32": `CGMScatterChart-module__gap-32___ttOtx`,
	"gap40": `CGMScatterChart-module__gap-40___MK3jS`,
	"gap50": `CGMScatterChart-module__gap-50___dRICh`,
	"flex1": `CGMScatterChart-module__flex-1___LTYjX`,
	"flexNone": `CGMScatterChart-module__flex-none___VzWRd`,
	"flexColumn": `CGMScatterChart-module__flex-column___IXnG0`,
	"flexRow": `CGMScatterChart-module__flex-row___IIyJA`,
	"verticallyCentered": `CGMScatterChart-module__vertically-centered___bO0OT`,
	"horizontallyCentered": `CGMScatterChart-module__horizontally-centered___M6hlk`,
	"horizontallyEnd": `CGMScatterChart-module__horizontally-end___TnhM5`,
	"verticallyStart": `CGMScatterChart-module__vertically-start___c7qkc`,
	"spaceBetween": `CGMScatterChart-module__space-between___SIyOK`,
	"flexWrap": `CGMScatterChart-module__flex-wrap___xqei9`,
	"height100": `CGMScatterChart-module__height-100___eTbjN`,
	"width50": `CGMScatterChart-module__width-50___z4jY6`,
	"width100": `CGMScatterChart-module__width-100___pEMWO`,
	"cursorPointer": `CGMScatterChart-module__cursor-pointer___mCQBm`,
	"cursorNotAllowed": `CGMScatterChart-module__cursor-not-allowed___w57SY`,
	"absoluteCentered": `CGMScatterChart-module__absolute-centered___aVINy`,
	"absolute": `CGMScatterChart-module__absolute___qbE1F`,
	"relative": `CGMScatterChart-module__relative___fXReZ`,
	"fixed": `CGMScatterChart-module__fixed___B_xMK`,
	"visible": `CGMScatterChart-module__visible___hJTai`,
	"invisible": `CGMScatterChart-module__invisible___P_7Ld`,
	"col90": `CGMScatterChart-module__col-90___EGQNL`,
	"colAuto": `CGMScatterChart-module__col-auto___NE3Li`,
	"medicalTabs": `CGMScatterChart-module__medical-tabs___khV9Q`,
	"medicalTableNew": `CGMScatterChart-module__medical-table-new___z6m_0`,
	"noPagination": `CGMScatterChart-module__no-pagination___w4FiD`,
	"medicalTableEmpty": `CGMScatterChart-module__medical-table-empty___v_QVi`,
	"iconBtn": `CGMScatterChart-module__icon-btn___gSnrz`,
	"searchIcon": `CGMScatterChart-module__search-icon___zN2PU`,
	"disableSelect": `CGMScatterChart-module__disable-select___eW22D`,
	"breakWord": `CGMScatterChart-module__break-word___rFBYP`,
	"popupClearBtn": `CGMScatterChart-module__popup-clear-btn___x66_P`,
	"scrollMB20": `CGMScatterChart-module__scroll-m-b-20___cG0Y_`,
	"chart": `CGMScatterChart-module__chart___YbwBo`,
	"emptyPlaceholder": `CGMScatterChart-module__emptyPlaceholder___WXvXy`
};
module.exports = ___CSS_LOADER_EXPORT___;
